<script lang="ts" setup>
import { ref,nextTick,computed } from 'vue'
import { MoreFilled } from '@element-plus/icons-vue'
import { ChatSession } from '@/typings'

const popoverShowStatus = ref(false);

//标记是否可编辑
const isEdit = ref(false);
//记录当前选中的会话
const focusedSession = ref({}as ChatSession);
// active：用来标记当前会话是否处于选中状态
// session：用于展示的会话信息
const props = defineProps<{ active: boolean; session: ChatSession }>()
// 定义删除事件，当触发删除事件时会向外部发送被删除的会话。
const emit = defineEmits<{
     pin: [session: ChatSession];
  delete: [session: ChatSession];
  switch: [session: ChatSession];
  update: [session: ChatSession];
}>()

const enterBlur = (event:Event) => {
    if(event.target)
    {
        (event.target as HTMLInputElement).blur();    
    }
}
const isPinned = computed(() => props.session.pin==1)
const popoverRef = ref({} as any);
const sendPinConversation = async () =>{
    if (popoverRef.value) {
        await popoverRef.value.hide(); // 等待菜单隐藏完成
        setTimeout(() => {
          emit('pin', props.session); // 延迟发送 pin 事件
        }, 200); // 使用0毫秒的延迟
      }
}
// 当鼠标放到会话上时，会弹出删除图标，点击删除图标调用删除接口并发送删除事件。
const sendDeleteConversation = () => {
    emit('delete', props.session);
}

const sendSwitchConversation = () => {
    emit('switch', props.session);
}

const showNameEditInput = () => {
    isEdit.value = true;
    popoverShowStatus.value = false;
    nextTick(() => {
      const inputElement = document.getElementById("sessionInputId");
      if (inputElement) {
        inputElement.focus();
      }
    })
}

const sendUpdateConversation = () => {
    isEdit.value = false;
    popoverShowStatus.value = false;
    emit('update', props.session);
}

const selectSession = () => {
    focusedSession.value = props.session;
}

const judgeEdit = () =>{
    return isEdit.value && focusedSession.value.guid == props.session.guid;
}

const show = ()=>
{
    popoverShowStatus.value = true;
}

const hide = ()=>
{
    popoverShowStatus.value = false;
}

</script>

<template>
  <!-- 如果处于激活状态则增加 active class -->
  <div :class="['session-item', active ? 'active' : '']">
    <!-- 会话的名称 -->
    <div v-if="judgeEdit()" class="name" id="edit-name">
        <!-- 按回车代表确认修改 -->
        <el-input 
        v-model="session.title" 
        class="name-input"
        id="sessionInputId" 
        @blur="sendUpdateConversation" 
        @keydown.enter.native="enterBlur($event)">
        </el-input>
      </div>
      <!-- 否则正常显示标题 -->
    <div v-else class="name" id="show-name"  @click="sendSwitchConversation">{{ session.title }}</div>
    <!-- 当鼠标放在会话上或编辑时会弹出遮罩 -->
    <div  v-if="judgeEdit() ||(focusedSession && focusedSession.guid === props.session.guid && popoverShowStatus)" class="mask-edit" ></div>
    <div  v-else class="mask" ></div>
    <!-- 当鼠标放在会话上时会弹出更多按钮 -->
    <div v-if="!judgeEdit()" :class="['btn-wrapper', { 'pinned': isPinned }]" >
     <el-popover popper-class="popover" ref="popoverRef"
     placement="bottom" trigger="click" @show="show" @hide="hide">
        <template #reference>
            <el-button v-if="!session.pin" class="more-button"   @click="selectSession" >
                <el-icon  class="el-icon-more">
                    <MoreFilled/>
                </el-icon>
            </el-button>
            <el-button v-else class="pinned-button"   @click="selectSession" >
                <i class="el-icon-pinned">
                    <span class="icon-content">a</span>
                </i>
              </el-button>
        </template>
        <div class="more-manu" :width="100" >

            <el-button v-if="!session.pin" class="pin-button" type="primary" @click="sendPinConversation">
                <i class="el-icon-pin">
                    <span class="icon-content">content</span>
                </i>
                    {{ $t("slider.pin") }}
            </el-button>
            <el-button v-else class="unpin-button" type="primary" @click="sendPinConversation">
                <i class="el-icon-unpin">
                    <span class="icon-content">content</span>
                </i>
                {{ $t("slider.unpin") }}
            </el-button>
            <el-button class="rename-button"  type="primary" @click="showNameEditInput" >
                <i class="el-icon-rename">
                    <span class="icon-content">content</span>
                </i>
                {{ $t("slider.rename") }}
            </el-button>
            <el-button class="delete-button"  type="primary" @click="sendDeleteConversation" >
                <i class="el-icon-delete">
                    <span class="icon-content">content</span>
                </i>
                {{ $t("slider.delete") }}
            </el-button>
        </div>
    </el-popover>


    </div>
  </div>
</template>



<style lang="scss" scoped>
@import "@/style/_handle.scss";

.session-item 
{
    background-color:inherit;

    /* 给边界一些圆角看起来圆润一些 */
    border-radius: 10px;
    display: flex;

    cursor: pointer;
    /* 父相子绝，父元素是相对布局的情况下，子元素的绝对布局是相当于父元素绝对布局。 */
    position: relative;
    /* 子元素的遮罩一开始会在外面，让溢出的遮罩不显示 */
    overflow: hidden;

    .name 
    {
        max-width: 130px;
        z-index: 10;
        font-size: 15px;
        padding-top: 10px;
        padding-bottom: 10px;
        padding-left: 10px;
        padding-right: 0px;
        width: 100%;
        height: 20px;
        min-height: 20px;
        /* 加粗后颜色淡一些 */
        @include font-color(font-color);
        white-space: nowrap; /* 禁止文本换行 */
        overflow: hidden; /* 隐藏超出容器部分的内容 */
        cursor: pointer;
        display: flex;
        flex-direction: column;
    }

    #show-name{

        mask-image: -webkit-linear-gradient(right, rgba(0, 0, 0, 0) 5%, rgba(0, 0, 0, 1) 30%); 

    }

    #edit-name{
        .name-input
        {
            //--el-input-border-color: rgb(255,255,255);
            //--el-input-focus-border-color: rgb(255,255,255);

            :deep(.el-input__wrapper) 
            {
                margin-top: -6px;
                margin-left: 0;
                background-color:inherit;
                box-shadow: 0 0 0 0px;
            }
            :deep(.el-input__inner) 
            {
                margin-left: -10px;
                @include font-color(font-color);
                font-size: 15px;
                border:0;
            }

        }
    }

   // 当处于激活状态时或鼠标位于会话上时触发 
    &.active, &:hover
    {
        #show-name
        {
            //文字末端渐变消失
            mask-image: -webkit-linear-gradient(right, rgba(0, 0, 0, 0) 30%, rgba(0, 0, 0, 1) 50%); 
        }

        .mask 
        {
            opacity: 1;
        }

        .btn-wrapper 
        {
            opacity: 1;
        }
    }

    .mask 
    {
        //显示层数，在文字下方
        z-index: 1;
        // 相当于父亲绝对布局
        position: absolute;
        //background-color: rgba(black, 0.1);
        @include background_color("mask-color");
        width: 100%;
        height: 100%;
        // 透明度为0
        opacity: 0;
        cursor:pointer; 
    }

    .mask-edit
    {
        //显示层数，在文字下方
        z-index: 1;
        // 相当于父亲绝对布局
        position: absolute;
        //background-color: rgba(black, 0.1);
        @include background_color("mask-color");
        width: 100%;
        height: 100%;
        // 透明度为0
        opacity: 1;
        cursor:pointer; 
    }

   //”更多“按钮样式
    .btn-wrapper 
    {
        position: absolute;
        top: 5px;
        right: 20px;
        height: 100px;
        //位于遮罩上方
        z-index: 10;
        //未选中时透明度为0
        opacity: 0;
        cursor:pointer; 
        &.pinned {
        opacity: 1;
        }
        .more-button {
            max-width: 20px;
            border: 0;
            font-size: 18px;
            padding-right: 0px;
            background-color: inherit;
            @include font-color(more-button-color);
            transform: translateX(10px); 
        }
        .pinned-button{
            //width: 100%;
            font-size: 15px;
            background-color:inherit;
            padding-left: 0%;
            padding-right: 0%;
            border: 0;
            transform: translateX(16px); 
            cursor:pointer; 
            @include font_color("font-color");
        }
        .el-icon-pinned
        {
            margin-right: 1px;
            background-size:cover;
            @include background_image("pin-fill-button-img");
            width:20px;
            height:20px;
        }
        .pinned-button:hover,
        .more-button:hover 
        {    
            @include font-color(more-button-color-hover);
        }
    }
}
</style>


<style lang="scss">
@import "@/style/_handle.scss";

//点击“更多”按钮后菜单样式
.popover
{
    min-width: 125px!important;
    width: 125px!important;
    border-color:rgb(170,170,170)!important;
    @include background_color("sidebar-background");

    .el-popper__arrow::before{
        @include background_color("sidebar-background");
        border-color:rgb(170,170,170)!important;
    }
    
    .more-manu
    {
        width: 120px;
        height: 100%;
        margin:-10px;
        background-color: inherit;
        display: flex;
        flex-direction: column;
    }

    .el-button + .el-button{
        margin: 0px;
        //margin-top: 5px;
    }
    .rename-button,
    .delete-button,
    .pin-button,
    .unpin-button,
    {
        display: flex;
        justify-content: flex-start;
        width: 100%;
        font-size: 15px;
        padding-top: 10px;
        padding-bottom: 20px;
        background-color:inherit;
        border: 0;
        cursor:pointer; 
        @include font_color("font-color");
    }
    .pin-button
    {

    }
    .rename-button 
    {
    }
    .pin-button:hover,
    .unpin-button:hover,
    .delete-button:hover,
    .rename-button:hover 
    {    
        @include background_color("mask-color");
        @include font_color("font-color");
        cursor:pointer; 
    } 
    
    .delete-button 
    {
        margin-left: -12px;
        margin-right: 0px;
    }

    // .delete-button:hover 
    // {    
    //     @include font_color("font-color");
    //     @include background_color("mask-color");
    //     cursor:pointer; 
    // }   

    
    .icon-content
    {
        visibility: hidden;
    }
    .el-icon-rename,
    .el-icon-delete,
    .el-icon-pin,
    .el-icon-unpin
    {
        width:16px;
        height:16px;
        background-size:cover;
        margin-right: 10px;
    }
    .el-icon-pin
    {
        transform: translateY(3px); /* 调整此值以控制向下移动的距离 */
        @include background_image("pin-button-img");
    }
    .el-icon-unpin
    {
        transform: translateY(3px); /* 调整此值以控制向下移动的距离 */
        @include background_image("pin-fill-button-img");
    }
    .el-icon-rename
    {
        @include background_image("rename-button-img");
    }

    .el-icon-delete
    {
        @include background_image("delete-button-img");
    }
    
}
</style>

